import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const getSettings = prop('settings');

export const getSplashScreen = createSelector(
  getSettings,
  prop('SPLASH_SCREEN'),
);

export const getUserDataEligibilityPdf = createSelector(
  getSettings,
  prop('USER_DATA_ELIGIBILITY_PDF'),
);

export const getAppointmentDeactivation = createSelector(
  getSettings,
  prop('APPOINTMENT_DEACTIVATION'),
);

export const getFnolWorkflow = createSelector(
  getSettings,
  prop('FNOL_WORKFLOW'),
);

export const getIsPublicApiV1 = createSelector(
  getSettings,
  prop('PUBLIC_APIv1_ACTIVATION'),
);

export const getIsPublicApiV4 = createSelector(
  getSettings,
  settings =>
    // eslint-disable-next-line camelcase
    settings?.PUBLIC_APIv4_ACTIVATION === true || settings?.PUBLIC_API_V4_ACTIVATION === true,
);

export const getIsPublicApiV5 = createSelector(
  getSettings,
  settings =>
    // eslint-disable-next-line camelcase
    settings?.PUBLIC_APIv5_ACTIVATION === true || settings?.PUBLIC_API_V5_ACTIVATION === true,
);

export const getIsDownsized = createSelector(
  getSettings,
  prop('EMBEDDED_WEBAPP_DOWNSIZE'),
);

export const getAdditionalTransportationQuestion = createSelector(
  getSettings,
  prop('ADDITIONAL_TRANSPORTATION_QUESTION'),
);

export const getActivateGA4 = createSelector(
  getSettings,
  prop('ACTIVATE_GA4'),
);

export const getDisplayCustomDestinationFrist = createSelector(
  getSettings,
  prop('DISPLAY_CUSTOM_DESTINATION_FIRST'),
);

export const getDisplayNetworkGarageContext = createSelector(
  getSettings,
  prop('DISPLAY_NETWORK_GARAGES_CONTEXT'),
);

export const getImpressumUrl = createSelector(
  getSettings,
  prop('IMPRESSUM_URL'),
);

export const getDisplayMileage = createSelector(
  getSettings,
  prop('ELIGIBILITYCHECK_MILEAGE_DISPLAYED'),
);

export const getDisplayVinNumber = createSelector(
  getSettings,
  prop('ELIGIBILITYCHECK_CAR_VIN_DISPLAYED'),
);

export const getDisplayLeaserContractNumber = createSelector(
  getSettings,
  prop('ELIGIBILITYCHECK_LEASER_CONTRACT_NUMBER_DISPLAYED'),
);

export const getRentalCarDisplayPlateNumber = createSelector(
  getSettings,
  settings => settings?.RENTAL_WORKFLOW?.RENTAL_CAR_PLATE_DISPLAYED,
);

export const getRentalCarDisplayVinNumber = createSelector(
  getSettings,
  settings => settings?.RENTAL_WORKFLOW?.RENTAL_CAR_VIN_DISPLAYED,
);

export const getRentalCarPhoneRequired = createSelector(
  getSettings,
  settings => settings?.RENTAL_WORKFLOW?.RENTAL_CAR_OTHER_LOCATION_PHONE_REQUIRED,
);

// Button visibility selectors

const BUTTONS = {
  RENTAL_EXTENSION_TIMELINE_VISIBLE: 'RENTAL_EXTENSION_TIMELINE_VISIBLE',
  RENTAL_EXTENSION_SUMMARY_VISIBLE: 'RENTAL_EXTENSION_SUMMARY_VISIBLE',
};

const createButtonVisibilitySelector = buttonKey =>
  createSelector(
    getSettings,
    settings => settings?.BUTTONS?.[buttonKey] !== false,
  );

export const getButtonVisibleRentalExtensionTimeline = createButtonVisibilitySelector(
  BUTTONS.RENTAL_EXTENSION_TIMELINE_VISIBLE,
);
export const getButtonVisibleRentalExtensionSummary = createButtonVisibilitySelector(
  BUTTONS.RENTAL_EXTENSION_SUMMARY_VISIBLE,
);
